module.exports = __webpack_public_path__ + "img/HearingDisabledOutlined.7b83777d.svg";